import { useContext, useEffect, useState } from 'react';
import equal from 'fast-deep-equal';
import SponsoredProductsContext from 'contexts/SponsoredProducts/SponsoredProductsContext';

const useSponsoredProducts = () => {
    const { state, actions } = useContext(SponsoredProductsContext);
    const [sponsoredData, setSponsoredData] = useState(state);
    useEffect(() => {
        if (!equal(sponsoredData, state)) setSponsoredData(state);
    }, [state]);
    return [state, actions];
};

export default useSponsoredProducts;
